// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"5007401682ab096c8d2e","303":"f30dd3f9c7722f8d59f2","495":"6573aaaa74645267f6d5"}[chunkId] + ".js";
};